import { configureStore } from '@reduxjs/toolkit';

import cartReducer from './cart/cartSlice';
import itemReducer from './item/itemSlice';
import orderReducer from './order/orderSlice';

export const store = configureStore({
    reducer: {
        item: itemReducer,
        order: orderReducer,
        cart: cartReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
